import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { SEO } from "@/components/motion";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(apiError(err, "Login failed. Please try again."));
      setLoading(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="flex min-h-screen items-center justify-center bg-blue-midnight px-5">
      <SEO title="Admin Login | HOMELARA" description="Private HOMELARA administration area." />
      <div className="w-full max-w-md rounded-3xl border border-blue-border bg-blue-card p-8 sm:p-10">
        <p className="font-serif text-3xl font-semibold tracking-[0.12em] text-canvas">HOMELARA</p>
        <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.25em] text-sage">Private admin area</p>

        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.2em] text-sage">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="w-full rounded-xl border border-blue-border bg-blue-midnight px-4 py-3.5 text-sm text-canvas outline-none focus:border-sage"
              placeholder="admin email"
            />
          </div>
          <div>
            <label className="mb-2 block font-mono text-[10px] uppercase tracking-[0.2em] text-sage">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="w-full rounded-xl border border-blue-border bg-blue-midnight px-4 py-3.5 text-sm text-canvas outline-none focus:border-sage"
              placeholder="password"
            />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-300">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full rounded-full bg-canvas py-4 font-mono text-xs uppercase tracking-[0.2em] text-blue transition-all hover:-translate-y-0.5 disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <Link to="/" data-testid="admin-login-back" className="mt-8 block text-center text-xs text-canvas/50 hover:text-canvas transition-colors">
          &larr; Back to website
        </Link>
      </div>
    </main>
  );
}
